import { useContext, useEffect, useState } from 'react';
import { apiContext } from '../../../../contexts/apiContext';
import { notifyError } from '../../../../components/snackbar/snackbar';
import Spinner from '../../../../components/spinner/spinner';
import { ClassNameSpinner } from '../../../../components/spinner/types/spinnerProps';
import { MessageAttachmentInfo, ReadMessageViewProps } from './types/readMessageViewProps';
import ButtonField from '../../../../components/buttonField/buttonField';
import { iconStyle, stylizationAlignRight, stylizationVerticalAlign } from '../../../../components/shared/stylization';
import { ButtonFieldProps } from '../../../../components/buttonField/types/buttonFieldProps';
import { classNameBtn } from '../../../../components/shared/button/types/buttonProps';
import { ReactComponent as AttachFile } from "../../../../icons/attach_file.svg";
import { ReactComponent as DownloadIcon } from "../../../../icons/download.svg";
import { formatDate } from '../../../../helpers/dateHelper';
import Line from '../../../../components/line/line';
import AttachFileRow from '../../../../components/attachFileRow/attachFileRow';
import { queryAttachments } from '../../../../services/arcGisService/arcGisService';
import AttachmentQuery from "@arcgis/core/rest/support/AttachmentQuery";
import { downloadFile } from '../../../../helpers/fileHelper';
import { getMail, readMessage } from '../../../../services/communicationService/communicationService';
import './messageView.scss';
import { AttachFileMode } from '../../../../components/attachFileRow/types/attachFileProps';

const ReadNMessageView = (props: ReadMessageViewProps) => {
    const api = useContext(apiContext);
    const [loading, setLoading] = useState<boolean>(true);
    const [mail, setMail] = useState<string>("");
    const [attachments, setAttachments] = useState<MessageAttachmentInfo[]>([]);

    useEffect(() => {
        const feature = props.feature;
        if (feature == null) return;
        const msgId = feature.attributes.ID;
        const url = api.apiUrl + api.apiVersion;

        setLoading(true);
        const promises = [];
        promises.push(getMail(url, feature.attributes.NADAWCA));

        const isRead = feature.attributes.STATUS_WIADOMOSCI_DOM !== "odczytana";
        if (isRead) {
            const url = api.apiUrl + api.apiVersion;
            promises.push(readMessage(url, msgId, true));
        }

        const hasAttachment = feature.attributes.LICZBA_ZALACZNIKOW > 0;
        if (hasAttachment) {
            const query = new AttachmentQuery({
                objectIds: [msgId]
            });
            promises.push(queryAttachments({ url: api.featureServices.messages }, query));
        }

        Promise.allSettled(promises).then((results) => {
            if (results[0].status === "fulfilled") {
                setMail(results[0].value);
            }
            if (isRead) {
                if (results[1].status === "fulfilled") {
                    const isSuccess = results[1].value;
                    if (!isSuccess) { showStatusChangeFailed(); }
                } else {
                    showStatusChangeFailed();
                }
            }
            if (hasAttachment) {
                const index = isRead ? 2 : 1;
                if (results[index].status === "fulfilled") {
                    // @ts-ignore: index check
                    const attachmentSet = results[index].value;
                    var attachmentInfos = prepareAttachmentResponse(attachmentSet, msgId);
                    setAttachments(attachmentInfos);
                } else {
                    showAttachmentFailed();
                }
            }
            setLoading(false);
        });

    }, [api.apiUrl, api.apiVersion, api.featureServices.messages, props.feature]);

    const prepareAttachmentResponse = (response: any, id: number) => {
        if (response == null || response[id] == null) return [];
        return response[id].map((a: any) => {
            return { id: a.id, name: a.name, url: a.url };
        });
    }

    const showStatusChangeFailed = () => {
        notifyError({ message: "Nie udało się zaktualizować statusu wiadomości" });
    }

    const showAttachmentFailed = () => {
        notifyError({ message: "Nie udało się pobrać załączników" });
    }

    const handleClose = () => {
        props.onRead(false, null);
    }

    const getBtnToggleProps = (): ButtonFieldProps => {
        var dataProps: ButtonFieldProps = {
            BtnProps: {
                onClick: handleClose,
                style: { height: '45px' },
                className: classNameBtn.Small + " body-txt-medium"
            },
            placeHolder: "Wróć do listy wiadomości",
            placeHolderStyle: stylizationVerticalAlign,
            wrapperProps: { style: stylizationAlignRight }
        };
        return dataProps;
    }

    const prepareDate = () => {
        const date = props.feature?.attributes?.DATA_WYSLANIA;
        if (date) {
            return formatDate(new Date(date), true);
        }
        return null;
    }

    const downloadAllClick = () => {
        attachments.forEach(a => {
            downloadFile(a.url, a.name);
        })
    }

    const handleAttachmentClick = (attachmentInfo: MessageAttachmentInfo) => {
        downloadFile(attachmentInfo.url, attachmentInfo.name);
    }

    const hasAttachment = props.feature?.attributes?.LICZBA_ZALACZNIKOW > 0;

    return (<>
        {loading ? <Spinner spinnerClass={ClassNameSpinner.Big} isMist={true} /> :
            <div className="readMessage-View">
                <div className='readMessage-header'>
                    <div className='readMessage-header-item'>Od: <strong>{props.feature?.attributes?.NAZWA_PELNA}</strong><span className='readMessage-mail'>{mail && `<${mail}>`}</span></div>
                    <div className='readMessage-header-item'>{hasAttachment && <AttachFile />}{prepareDate()}</div>
                </div>
                <div className='readMessage-text'>{props.feature?.attributes?.TRESC}</div>
                <Line />
                {hasAttachment && <div className='readMessage-header'>
                    <h3>Załączniki</h3>
                    <div className='readMessage-header-item'>
                        <DownloadIcon style={iconStyle} title="Pobierz wszystkie załączniki" onClick={downloadAllClick} />
                    </div>
                </div>
                }
                <div className="attachRow-content">
                    {attachments.map(attachment => {
                        return <AttachFileRow key={attachment.id} mode={AttachFileMode.Download} info={attachment} onClick={handleAttachmentClick} />
                    })}
                </div>
                <ButtonField {...getBtnToggleProps()} />
            </div>}
    </>)
}

export default ReadNMessageView;